/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Pausereasonname2Inputs */

const en_entity_pausereasonname2 = /** @type {(inputs: Entity_Pausereasonname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Reason Name`)
};

const de_entity_pausereasonname2 = /** @type {(inputs: Entity_Pausereasonname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Pause Reason Name" |
*
* @param {Entity_Pausereasonname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_pausereasonname2 = /** @type {((inputs?: Entity_Pausereasonname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Pausereasonname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_pausereasonname2(inputs)
	return de_entity_pausereasonname2(inputs)
});
export { entity_pausereasonname2 as "entity_pauseReasonName" }